export default {
  getDriverHelperNamesByAuthIds: (state, getters, rootState) => (authIds) => {
    if (Array.isArray(state.allDriverHelpers) && state.allDriverHelpers.length > 0 && Array.isArray(authIds)) {
      return state.allDriverHelpers
        .filter(helper => authIds.includes(helper.auth_uid))
        .map(helper => helper.name)
    }
    return []
  }
}